export default __webpack_public_path__ + "static/media/a.aef44bfd.png";